import { createContext, useContext } from 'react';
import { ExclusionProduct } from '@/data/Content/RepurchaseExclusionRules';

export type RepurchasePricing = {
	percentage: number;
	isExcluded: (product: ExclusionProduct) => boolean;
};

export const RepurchasePricingEnabledContext = createContext(false);

export const RepurchasePricingContext = createContext<RepurchasePricing | undefined>(undefined);

export const useRepurchasePricingEnabled = () => useContext(RepurchasePricingEnabledContext);

export const useRepurchasePricing = () => useContext(RepurchasePricingContext);
